import { AgeGenderDialogContext } from '@rhg/providers/age-gender-dialog';
import { useContext } from 'react';

export default function useAgeGenderDialog() {
    return useContext(AgeGenderDialogContext);
}
